
// Libraries
import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from '../../../../routes/routes';
import phrasebookLoad from "../../../../i18n";
import * as token from '../../../../helpers/token';
import { accountTypesConstants, portalFunctionalityConstants, permissionTypeConst } from '../../../../constants';
import { permissionFinder } from "../../../../helpers/util"
import { ModalGenerator } from '../../../../components/SkyFramework/Modal'



// Redux
import { customerActions, accountActions, georesourceActions } from 'actions';

// Components
import { Table } from "../../../../components/SkyFramework/Tables/Table";
import { NewBreadcrumbs } from "../../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SearchBox } from "../../../../components/SkyFramework/Search";
import { PaginationBar } from "../../../../components/SkyFramework/Pagination/PaginationBar.jsx";

// Constants
const phrasebook = phrasebookLoad()

class Customers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      customers: undefined,
      pccwglobal_accounts: undefined,
      pccwglobal_sales_link_accounts: undefined,

      pccwglobal_signed_bdm_id: undefined,
      address_country: undefined,
      address_city: undefined,
      address_line_1: undefined,
      address_line_2: undefined,
      address_line_3: undefined,
      address_postcode: undefined,

      filters: { orderby: 'name', asc: true },
      countries: undefined,
      onSearch: false,
      limit: 10,
      page: 1
    };

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDeleteSubmit = this.handleDeleteSubmit.bind(this);

  }

  componentDidMount() {
    // this.props.dispatch(accountActions.getAllAccounts(0, this.state.page, { pccwglobal_account_type: true }));
    this.props.dispatch(georesourceActions.getCountries(undefined, 1000));
    this.props.dispatch(customerActions.getAll(this.state.limit, 0, this.state.filters));
  }

  componentDidUpdate(prevProps) {
    // if (this.props.accounts && prevProps && prevProps.accounts !== this.props.accounts) {
    //   this.setState({ pccwglobal_sales_link_accounts: this.props.accounts.data.filter(account => account.account_type_id === accountTypesConstants.PCCW_SALES) });
    //   this.setState({ pccwglobal_accounts: this.props.accounts.accounts })
    // }
    if (this.props.customers && prevProps && prevProps.customers !== this.props.customers) {
      this.setState({ customers: this.props.customers });
      if (this.state.onSearch) {
        this.setState({ onSearch: false, page: 1 });
      }
    }
  }

  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    var searchValues = {
      pccwglobal_signed_bdm_id: this.state.pccwglobal_signed_bdm_id,
      country: this.state.country,
      orderby: 'name', asc: true
    }
    this.setState({ filters: searchValues, onSearch: true });
    this.props.dispatch(customerActions.getAll(this.state.limit, 0, searchValues));
  }

  handleDeleteSubmit = (event) => {
    const { id } = event.target;
    this.props.dispatch(customerActions.remove(id));
  }

  onPageChanged = currentPage => {
    this.setState({ page: currentPage });
    this.props.dispatch(customerActions.getAll(this.state.limit, currentPage - 1, this.state.filters));
  }


  SearchBox() {
    if (this.state.pccwglobal_sales_link_accounts) {
      const sales = this.state.pccwglobal_sales_link_accounts.map(function (account) {
        return { value: account['id'], label: `${account.username} - ${account.userprofile.firstname} ${account.userprofile.lastname}` };
      });
      var filters = [
        {
          label: phrasebook.references.sales_link, type: "select", id: "pccwglobal_signed_bdm_id",
          tooltip: 'Contact in sales team', name: "pccwglobal_signed_bdm_id", options: sales, empty_option: true
        },
      ]

      return (
        <SearchBox
          filters={filters}
          buttonTitle={phrasebook.common.search}
          onClick={this.handleSearchSubmit}
          onChange={this.handleChange}
        />)
    } else return null;
  }

  canAdd() {
    if (permissionFinder(this.props.loggedpermissions.loggedPermissions, token.loggedAccountType(), portalFunctionalityConstants.account.customer, permissionTypeConst.ADD, token.loggedToken())) return <div class="ml-sm-auto mt-1 mt-sm-0"><Link to={gisRoutes.account.customer.add}>
      <button type="button" class="btn btn-main">
        {phrasebook.profile.add_customer}
      </button>
    </Link>
      <Link to={gisRoutes.account.customer.bulk}>
        <button type="button" class="btn btn-main">
          {phrasebook.common.bulk} {phrasebook.common.add} {phrasebook.common.customers}
        </button>
      </Link>
    </div>
  }

  CustomersList() {
    if (this.state.customers) {

      var labels = [
        phrasebook.profile.company,
        phrasebook.profile.company_alias,
        phrasebook.common.website,
        phrasebook.profile.vendor_code,
        phrasebook.profile.jurisdiction,
        // phrasebook.profile.commercial_contact_name,
        // phrasebook.profile.commercial_contact_email
      ]
      var fields = ['name', 'former_name', 'website', 'pccwglobal_insight_company_code', 'business_jurisdiction'];

      var actions = [];
      if (permissionFinder(this.props.loggedpermissions.loggedPermissions, token.loggedAccountType(), portalFunctionalityConstants.account.customer, permissionTypeConst.EDIT, token.loggedToken())) actions.push({
        location: gisRoutes.account.customer.edit,
        label: phrasebook.common.edit,
        type: 'link'
      });
      if (permissionFinder(this.props.loggedpermissions.loggedPermissions, token.loggedAccountType(), portalFunctionalityConstants.account.customer, permissionTypeConst.DELETE, token.loggedToken())) actions.push({
        location: gisRoutes.account.customer.delete,
        label: phrasebook.common.delete,
        type: 'modal'
      })

      return (<>
        {this.canAdd()}
        <br></br>
        <Table
          values={this.state.customers.data}
          limit={this.state.limit}
          currentPage={this.state.page}
          pageNeighbours={this.state.pageNeighbours}
          onPageChanged={this}
          nofound={phrasebook.common.nodatafound}
          headers={labels}
          keys={fields}
          actions={actions}
          action_key={'id'}
        />
        <PaginationBar limit={this.state.limit}
          total={this.state.customers.count}
          currentPage={this.state.page}
          onPageChanged={this}
          pageNeighbours={this.state.pageNeighbours} />
      </>)
    } else return null;
  }

  render() {
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }]} current={phrasebook.headerlinks.customers} />

      <div className="box p-1 p-sm-2">
        <h2 className="box-title pb-1 mb-1">{phrasebook.headerlinks.customers} {phrasebook.headerlinks.information}</h2>
        {/* {this.SearchBox()} */}

      </div>
      <div className="box p-1 p-sm-2 my-md-1">
        <h3 className="box-title pb-1 mb-1">{phrasebook.headerlinks.customers}</h3>
        {this.CustomersList()}
      </div>
      {this.state.customers ? <ModalGenerator
        rows={this.state.customers.data}
        title={phrasebook.profile.delete_customer}
        description={phrasebook.profile.delete_customer_sure}
        cancelLabel={phrasebook.common.cancel}
        confirmLabel={phrasebook.common.confirm}
        onClick={this.handleDeleteSubmit}
      /> : null}
    </>
  }
}

function mapStateToProps(state) {
  const { customer, authentication, account, loggedpermissions } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    customers: customer.customers,
    accounts: account.accounts,
  };
}

const customers = connect(mapStateToProps)(Customers);

//export default withStyles(styles)(partnersite);
export default (customers);
